import { DataType, FunctionDataType, SecretDataType } from '../DataType';

export function isFunctionDataType(dataType: DataType): dataType is FunctionDataType {
    return dataType.kind === 'function';
}

export function isSecretDataType(dataType: DataType): dataType is SecretDataType {
    return dataType.kind === 'secret';
}
